import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import reducers from '../../shared/reducers';
import { getApiAxiosInstance, getEngageApiAxiosInstance, getGroupsApiAxiosInstance, getLeaguesApiAxiosInstance, getMessagingApiAxiosInstance, getPerformanceStatsApiAxiosInstance, getRankingsApiAxiosInstance, getUtrStatsApiAxiosInstance } from '../../shared/utils/network';

export default function makeStore() {
    const axiosInstances = { mainApi: getApiAxiosInstance(), msgApi: getMessagingApiAxiosInstance(), leaguesApi: getLeaguesApiAxiosInstance(), groupsApi: getGroupsApiAxiosInstance(), engageApi: getEngageApiAxiosInstance(), rankingsApi: getRankingsApiAxiosInstance(), utrStatsApi: getUtrStatsApiAxiosInstance(), performanceStatsApi: getPerformanceStatsApiAxiosInstance() };
    // axiosInstance.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

    const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

    const store = createStore(
        reducers,
        window.INITIAL_STATE,
        composeEnhancers(
            applyMiddleware(thunk.withExtraArgument(axiosInstances)),
        ),
    );

    if (module.hot) {
        module.hot.accept('../../shared/reducers', () => {
            store.replaceReducer(reducers);
        });
    }

    return store;
}
